import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TransportCatalogFacade } from './transport-catalog.facade';
import { loadStoreState, setInitialStoreState } from '../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class TransportCatalogGuard {
  constructor(private transportCatalogFacade: TransportCatalogFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.transportCatalogFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.transportCatalogFacade);
  }
}
